import { useContext } from "react";
import getExperimentsContext from "./getExperimentsContext";
import { OptimizelyClient, User, UserContext } from "../types";
import { Resolve, OptimizelyProduct } from "./types";

type OptimizelyHook = {
  type: OptimizelyProduct;
};

export type FxOptimizelyHook = Resolve<
  OptimizelyHook & {
    type: "featureExperimentation";
    userContext: UserContext;
    updateUserContext: (customUserAttributes: Record<string, unknown>) => void;
  }
>;

export type FsOptimizelyHook = Resolve<
  OptimizelyHook & {
    type: "fullStack";
    optimizelyClient: OptimizelyClient;
    user: User;
  }
>;

function useOptimizely(
  optimizelyProjectType?: "featureExperimentation",
): FxOptimizelyHook;
function useOptimizely(optimizelyProjectType?: "fullStack"): FsOptimizelyHook;
function useOptimizely(
  optimizelyProjectType: OptimizelyProduct = "featureExperimentation",
): FxOptimizelyHook | FsOptimizelyHook {
  const ExperimentsContext = getExperimentsContext();
  const { user, optimizelyClient, userContext, updateUserContext } =
    useContext(ExperimentsContext);

  const userCopy = { ...user };

  if (optimizelyProjectType === "fullStack") {
    return {
      type: "fullStack",
      optimizelyClient,
      user: Object.freeze(userCopy),
    };
  }

  return { type: "featureExperimentation", userContext, updateUserContext };
}

export default useOptimizely;
